import * as types from './mutations-type'
import NavigationService from '../services/NavigationService'

export default {
  setMini({ commit }, value) {
    commit(types.SET_MINI, value)
  },
  toggleMini({ commit }) {
    commit(types.TOGGLE_MINI)
  },
  initNavigationRules({ commit }) {
    const rules = NavigationService.getNavigationRules()
    commit(types.INIT_NAVIGATION_RULES, rules)
    
    // Cargar items deshabilitados desde localStorage
    const savedDisabledItems = localStorage.getItem('disabledMenuItems')
    if (savedDisabledItems) {
      commit(types.SET_DISABLED_ITEMS, JSON.parse(savedDisabledItems))
    }
  },
  toggleMenuItem({ commit, state }, key) {
    commit(types.TOGGLE_MENU_ITEM, key)
    // Guardar en localStorage
    localStorage.setItem('disabledMenuItems', JSON.stringify(state.disabledMenuItems))
  },

  async updateMenuOrder({ commit }, orderedItems) {
    try {
      await NavigationService.updateMenuOrder(orderedItems)
      commit(types.UPDATE_MENU_ORDER, orderedItems)
      return true
    } catch (error) {
      console.error('Error updating menu order:', error)
      throw error
    }
  },

  async saveNavigationRules({ commit }, rules) {
    try {
      await NavigationService.saveNavigationRules(rules)
      commit(types.SAVE_NAVIGATION_RULES, rules)
      return true
    } catch (error) {
      console.error('Error saving navigation rules:', error)
      throw error
    }
  },

  async removeMenuItem({ commit, dispatch, state }, itemId) {
    try {
      const [parentKey, childKey] = itemId.split('-')
      const defaultRules = NavigationService.DEFAULT_RULES
      let updatedRules = { ...state.navigationRules }

      // 1. Eliminar el ítem manteniendo los ítems por defecto
      if (childKey) {
        if (updatedRules[parentKey]?.subMenu) {
          delete updatedRules[parentKey].subMenu[childKey]
          if (Object.keys(updatedRules[parentKey].subMenu).length === 0) {
            // Si el submenú queda vacío, restaurar el ítem padre por defecto
            updatedRules[parentKey] = defaultRules[parentKey] || updatedRules[parentKey]
            delete updatedRules[parentKey].subMenu
          }
        }
      } else {
        // Si es un ítem personalizado, eliminarlo
        if (updatedRules[itemId]?.isEditable) {
          delete updatedRules[itemId]
        }
        // Si es un ítem por defecto, restaurarlo
        else if (defaultRules[itemId]) {
          updatedRules[itemId] = defaultRules[itemId]
        }
      }

      // 2. Guardar las reglas actualizadas
      await NavigationService.saveNavigationRules(updatedRules)
      
      // 3. Actualizar Vuex
      commit(types.SAVE_NAVIGATION_RULES, updatedRules)
      
      // 4. Limpiar localStorage
      if (state.disabledMenuItems.includes(itemId)) {
        const newDisabledItems = state.disabledMenuItems.filter(item => item !== itemId)
        commit(types.SET_DISABLED_ITEMS, newDisabledItems)
        localStorage.setItem('disabledMenuItems', JSON.stringify(newDisabledItems))
      }

      // 5. Recargar las reglas
      dispatch('initNavigationRules')

      return true
    } catch (error) {
      console.error('Error removing menu item:', error)
      throw error
    }
  },

  async saveMenuItem({ commit, state }, { key, item }) {
    try {
      // Guardar el nuevo item en las reglas existentes
      const updatedRules = {
        ...state.navigationRules,
        [key]: {
          ...item,
          isEditable: true
        }
      }
      
      // Guardar en el servicio
      await NavigationService.saveNavigationRules(updatedRules)
      
      // Actualizar el estado
      commit(types.SET_CUSTOM_MENU_ITEM, { key, item })
      
      // Forzar reinicialización de las reglas
      const refreshedRules = NavigationService.getNavigationRules()
      commit(types.INIT_NAVIGATION_RULES, refreshedRules)
      
      return true
    } catch (error) {
      console.error('Error saving menu item:', error)
      throw error
    }
  }
}
